/**
 * Canonical network options used across Recharge, Withdraw, and Admin user-management.
 *
 * Rules:
 * - BTC supports only "BTC" network.
 * - All other coins offer: Ethereum (ERC20), BEP20 (BSC), TRC20 (Tron), Polygon, Base, Solana.
 */

export const NETWORK_LABELS = {
  ETHEREUM: 'Ethereum (ERC20)',
  BEP20: 'BEP20 (BSC)',
  TRC20: 'TRC20 (Tron)',
  POLYGON: 'Polygon',
  BASE: 'Base',
  SOLANA: 'Solana',
  BTC: 'BTC',
};

export const STANDARD_NETWORK_OPTIONS = [
  NETWORK_LABELS.ETHEREUM,
  NETWORK_LABELS.BEP20,
  NETWORK_LABELS.TRC20,
  NETWORK_LABELS.POLYGON,
  NETWORK_LABELS.BASE,
  NETWORK_LABELS.SOLANA,
];

export const BTC_NETWORK_OPTIONS = [NETWORK_LABELS.BTC];

/**
 * Return the network dropdown options for a given coin symbol.
 */
export const getNetworkOptionsForCoin = (coin) => {
  const normalized = (coin || '').toUpperCase();
  if (normalized === 'BTC') return BTC_NETWORK_OPTIONS;
  return STANDARD_NETWORK_OPTIONS;
};

/**
 * Normalize a free-form network string (as stored in the backend / config)
 * to one of the canonical labels above. Returns null if no match.
 */
export const normalizeNetwork = (raw) => {
  if (!raw) return null;
  const s = String(raw).toLowerCase().trim();

  if (s.includes('bitcoin') || s === 'btc' || s === 'btc network') return NETWORK_LABELS.BTC;
  if (s.includes('erc20') || s.includes('ethereum') || s === 'eth' || s === 'eth network') return NETWORK_LABELS.ETHEREUM;
  if (s.includes('bep20') || s.includes('bsc') || s.includes('binance')) return NETWORK_LABELS.BEP20;
  if (s.includes('trc20') || s.includes('tron')) return NETWORK_LABELS.TRC20;
  if (s.includes('polygon') || s.includes('matic')) return NETWORK_LABELS.POLYGON;
  if (s === 'base' || s.includes(' base') || s.startsWith('base ')) return NETWORK_LABELS.BASE;
  if (s.includes('solana') || s === 'sol') return NETWORK_LABELS.SOLANA;

  return null;
};

/**
 * Check whether a stored network string corresponds to the given canonical label.
 */
export const matchesNetwork = (storedNetwork, canonicalLabel) => {
  if (!storedNetwork || !canonicalLabel) return false;
  return normalizeNetwork(storedNetwork) === canonicalLabel;
};
